// extracted by mini-css-extract-plugin
module.exports = {"image_holder":"SubBlogPostStyle-module--image_holder--EdRf2","image":"SubBlogPostStyle-module--image--1sPgv","title":"SubBlogPostStyle-module--title--aF7Tg"};